// Public, platform-agnostic React code of @streamplace/core.
export * from "./vod-store";

export * from "./livestream-store";

export * from "./hooks/use-actor-typeahead";
export * from "./lib/badge-label";
export * from "./lib/browser";
export * from "./lib/did";
export * from "./lib/facet";
export * from "./lib/game";
export * from "./lib/pds-hosts";
export { getPlatform } from "./lib/platform";
export type { CorePlatform } from "./lib/platform";
